import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import cleanString from './cleanString'

export const createFAQSchema = (faqList) => {
  if (!faqList) {
    return null
  }

  return `{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    ${faqList
      .map((faq) => {
        let answer = ''
        try {
          answer = documentToPlainTextString(JSON.parse(faq.faqAnswer.raw))
        } catch (err) {
          console.log('failed to parse faq', err)
        }

        return `{
          "@type": "Question",
          "name": "${cleanString(faq.faqQuestion)}",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "${cleanString(answer)}"
          }
        }`
      })
      .join(',')}
  ]
}`
}
